import styled from 'styled-components'
import { Image } from 'react-bootstrap'

const LoginImage = styled(Image)`
  object-fit: cover;
  border-radius: 0.8rem;
  min-height: 100%;
  max-height: 350px;
  min-width: 100%;
  max-width: 100%;
`

export { LoginImage }
